import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errorMessage } from "@/lib/api";
import { AuthShell, FormError } from "./AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState("");
  const [warn, setWarn] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDone(data.message);
      const { data: status } = await api.get("/system/status");
      setWarn(status.account_email.last_result === "failed");
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell eyebrow="Account recovery" title="Reset your password" subtitle="Enter the email you signed up with. We'll send a link to choose a new password."
      footer={<Link to="/signin" data-testid="forgot-back-signin-link" className="font-medium text-navy underline underline-offset-4">Back to sign in</Link>}>
      {done ? (
        <div className="space-y-4">
          <p data-testid="forgot-password-success" className="rounded-md border border-gold/40 bg-gold-light/50 p-4 text-sm text-navy">{done} The link works for 1 hour.</p>
          {warn && (
            <p data-testid="forgot-password-delivery-warning" className="rounded-md border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900">
              Our most recent email failed to send. If nothing arrives, email delivery may be unavailable. Please try again later.
            </p>
          )}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-password-form">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" data-testid="forgot-email-input" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-11" />
          </div>
          <FormError message={error} testId="forgot-error" />
          <Button type="submit" disabled={busy} data-testid="forgot-submit-button" className="h-11 w-full bg-navy hover:bg-navy-2">
            {busy ? "Sending..." : "Send reset link"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
